import { render, staticRenderFns } from "./discount-radar.vue?vue&type=template&id=e9db0906&scoped=true&"
import script from "./discount-radar.vue?vue&type=script&lang=js&"
export * from "./discount-radar.vue?vue&type=script&lang=js&"
import style0 from "./discount-radar.vue?vue&type=style&index=0&id=e9db0906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9db0906",
  null
  
)

export default component.exports